import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";

import If from "~/core/ui/If";

import { faLock } from "@fortawesome/free-solid-svg-icons";

import { SubscriptionPlan } from "../../enums";
import { useSubscriptionCheckout } from "../../hooks/useSubscriptionCheckout";

const LoadingSpinner = () => (
  <motion.div
    className="h-5 w-5 rounded-full border-2 border-white border-t-transparent"
    animate={{ rotate: 360 }}
    transition={{
      duration: 1,
      ease: "linear",
      repeat: Infinity,
    }}
  />
);

const SubscriptionButton = () => {
  const { mutateAsync: checkoutSubscription, isPending } =
    useSubscriptionCheckout();

  return (
    <button
      className="w-full rounded-xl bg-core-blue-9 px-4 py-3 text-white-a12 shadow-md shadow-core-blue-a3 transition-colors hover:bg-core-blue-a10 h-16 flex items-center justify-center"
      onClick={() => checkoutSubscription(SubscriptionPlan.PRO)}
      disabled={isPending}
    >
      <If condition={!isPending} fallback={<LoadingSpinner />}>
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faLock} className="h-4 w-4" />
            <span className="text-sm font-semibold leading-snug">
              Unlock My CRM
            </span>
          </div>
          <p className="mt-1 text-size-2 leading-tight">
            1000 spots. You&apos;ve got one.
          </p>
        </div>
      </If>
    </button>
  );
};

export default SubscriptionButton;
